// extracted by mini-css-extract-plugin
export default {"root":"MessageContent_root__-7KjU","textMsg":"MessageContent_textMsg__2gwoT"};